import React, {useEffect} from 'react';
import {ThemeProvider} from '@rneui/themed';
import {observer} from 'mobx-react';

import ProductGrid from '../../components/ProductGrid';
import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {useStores} from '../../stores/use-stores';
import rewardsTheme from '../../theme/rewardsTheme';
import { getProductDisplayRules } from '../../utils/rewards';
const MembersPriceListScreen = observer(
  ({
    navigation,
    route,
  }: RouteNavigatorScreenProps<AppRoute.MEMBERS_PRICE_LIST>) => {
    const {external_sell_type} = route.params;

    const {rewardsStore} = useStores();

    /**
     * only allow just-for-you or members-price
     */
    useEffect(() => {
      if (!['just-for-you', 'members-price'].includes(external_sell_type)) {
        navigation.navigate(AppRoute.ROOT, {
          screen: AppRoute.MAIN,
          params: {screen: AppRoute.HOME},
        });
      }
    }, [external_sell_type, navigation]);

    /**
     * just-for-you requires hasRewards
     */
    useEffect(() => {
      if (external_sell_type === 'just-for-you') {
        if (!rewardsStore.hasRewards) {
          navigation.navigate(AppRoute.ROOT, {
            screen: AppRoute.MAIN,
            params: {
              screen: AppRoute.MEMBERS_PRICE_LIST,
              params: {
                external_sell_type: 'members-price',
              },
            },
          });
        }
      }
    }, [external_sell_type, navigation, rewardsStore.hasRewards]);

    const member_price =
      external_sell_type === 'just-for-you' ? 'private' : 'public';

    const store = useStores().getLinesStore({member_price});

    const products = store?.lines.filter(product => {
      const displayRules = getProductDisplayRules(product);
      const showProduct = member_price === 'public' ? displayRules.presentAsPublicMemberProduct : 
        member_price === 'private' ? displayRules.presentAsPrivateMemberProduct : true;

      return showProduct;
    });

    return (
      <ThemeProvider theme={rewardsTheme}>
        <ProductGrid items={products} isLoading={store?.isLoading} />
      </ThemeProvider>
    );
  },
);

export default MembersPriceListScreen;
